export default __webpack_public_path__ + "bb33a496630c86727d586cea9e823f4a.png";